import { RecProjectCategory, RecProgramYear } from './recs';

export interface IllinoisRecValuesProps {
  min: number;
  max: number;
  GROUP_A: number;
  GROUP_B: number;
}

//additional program years to be added in the future
export const IllinoisRecValues = [
  { category: RecProjectCategory.DISTRIBUTED_GENERATION, 
    year: RecProgramYear.YEAR_2024_2025, 
    data: [
      { min: 0, max: 10, GROUP_A: 73.71, GROUP_B: 83.87 },
      { min: 11, max: 25, GROUP_A: 63.53, GROUP_B: 77.53 },
      { min: 26, max: 100, GROUP_A: 55.89, GROUP_B: 70.23 },
      { min: 101, max: 200, GROUP_A: 53.63, GROUP_B: 63.34 },
      { min: 201, max: 500, GROUP_A: 46.58, GROUP_B: 54.60 },
      { min: 501, max: 2000, GROUP_A: 43.77, GROUP_B: 49.49 },
      { min: 2001, max: 5000, GROUP_A: 33.03, GROUP_B: 37.05 },
    ] 
  },
  { category: RecProjectCategory.TRADITIONAL_COMMUNITY_SOLAR, 
    year: RecProgramYear.YEAR_2024_2025, 
    data: [
      { min: 0, max: 25, GROUP_A: 57.49, GROUP_B: 70.91 },
      { min: 26, max: 100, GROUP_A: 58.84, GROUP_B: 72.15 },
      { min: 101, max: 200, GROUP_A: 57.50, GROUP_B: 69.58 },
      { min: 201, max: 500, GROUP_A: 53.46, GROUP_B: 64.20 },
      { min: 501, max: 2000, GROUP_A: 46.02, GROUP_B: 54.24 },
      { min: 2001, max: 5000, GROUP_A: 33.99, GROUP_B: 39.98 },
    ] 
  },
  { category: RecProjectCategory.COMMUNITY_DRIVEN_COMMUNITY_SOLAR, 
    year: RecProgramYear.YEAR_2024_2025, 
    data: [
      { min: 0, max: 25, GROUP_A: 73.82, GROUP_B: 91.47 },
      { min: 26, max: 100, GROUP_A: 75.40, GROUP_B: 92.92 },
      { min: 101, max: 200, GROUP_A: 73.28, GROUP_B: 89.36 },
      { min: 201, max: 500, GROUP_A: 67.73, GROUP_B: 82.24 },
      { min: 501, max: 2000, GROUP_A: 57.93, GROUP_B: 68.95 },
      { min: 2001, max: 5000, GROUP_A: 41.94, GROUP_B: 49.79 },
    ] 
  },
  { category: RecProjectCategory.PUBLIC_SCHOOLS, 
    year: RecProgramYear.YEAR_2024_2025, 
    data: [
      { min: 0, max: 25, GROUP_A: 77.17, GROUP_B: 93.17 },
      { min: 26, max: 100, GROUP_A: 68.57, GROUP_B: 84.96 },
      { min: 101, max: 200, GROUP_A: 65.81, GROUP_B: 76.91 },
      { min: 201, max: 500, GROUP_A: 57.72, GROUP_B: 66.88 },
      { min: 501, max: 2000, GROUP_A: 54.51, GROUP_B: 61.04 },
      { min: 2001, max: 5000, GROUP_A: 42.15, GROUP_B: 46.74 },
    ] 
  },
  { category: RecProjectCategory.DISTRIBUTED_GENERATION, 
    year: RecProgramYear.YEAR_2025_2026, 
    data: [
      { min: 0, max: 10, GROUP_A: 66.34 , GROUP_B: 75.48 },
      { min: 11, max: 25, GROUP_A: 57.18, GROUP_B: 69.78 },
      { min: 26, max: 100, GROUP_A: 59.53, GROUP_B: 69.65 },
      { min: 101, max: 200, GROUP_A: 55.63, GROUP_B: 65.09 },
      { min: 201, max: 500, GROUP_A: 45.64, GROUP_B: 53.40 },
      { min: 501, max: 2000, GROUP_A: 42.37, GROUP_B: 49.57 },
      { min: 2001, max: 5000, GROUP_A: 31.96, GROUP_B: 37.39 },
    ] 
  },
  { category: RecProjectCategory.TRADITIONAL_COMMUNITY_SOLAR, 
    year: RecProgramYear.YEAR_2025_2026, 
    data: [
      { min: 0, max: 25, GROUP_A: 57.49, GROUP_B: 70.91 },
      { min: 26, max: 100, GROUP_A: 58.84, GROUP_B: 72.15 },
      { min: 101, max: 200, GROUP_A: 57.50, GROUP_B: 69.58 },
      { min: 201, max: 500, GROUP_A: 53.40, GROUP_B: 64.20 },
      { min: 501, max: 2000, GROUP_A: 46.02, GROUP_B: 54.24 },
      { min: 2001, max: 5000, GROUP_A: 33.99, GROUP_B: 39.98 },
    ] 
  },
  { category: RecProjectCategory.COMMUNITY_DRIVEN_COMMUNITY_SOLAR, 
    year: RecProgramYear.YEAR_2025_2026, 
    data: [
      { min: 0, max: 25, GROUP_A: 73.82, GROUP_B: 91.47 },
      { min: 26, max: 100, GROUP_A: 75.40, GROUP_B: 92.92 },
      { min: 101, max: 200, GROUP_A: 73.28, GROUP_B: 89.36 },
      { min: 201, max: 500, GROUP_A: 67.73, GROUP_B: 82.24 },
      { min: 501, max: 2000, GROUP_A: 57.93, GROUP_B: 68.95 },
      { min: 2001, max: 5000, GROUP_A: 41.94, GROUP_B: 49.79 },
    ] 
  },
  { category: RecProjectCategory.PUBLIC_SCHOOLS,
    year: RecProgramYear.YEAR_2025_2026,
    data: [
      { min: 0, max: 25, GROUP_A: 77.17, GROUP_B: 93.17 },
      { min: 26, max: 100, GROUP_A: 68.57, GROUP_B: 84.96 },
      { min: 101, max: 200, GROUP_A: 65.81, GROUP_B: 76.91 },
      { min: 201, max: 500, GROUP_A: 57.72, GROUP_B: 66.88 },
      { min: 501, max: 2000, GROUP_A: 54.51, GROUP_B: 61.04 },
      { min: 2001, max: 5000, GROUP_A: 42.15, GROUP_B: 46.74 },
    ]
  },
  { category: RecProjectCategory.DISTRIBUTED_GENERATION,
    year: RecProgramYear.YEAR_2026_2027,
    data: [
      { min: 0, max: 10, GROUP_A: 70.37, GROUP_B: 80.77 },
      { min: 11, max: 25, GROUP_A: 60.92, GROUP_B: 79.21 },
      { min: 26, max: 100, GROUP_A: 59.53, GROUP_B: 69.65 },
      { min: 101, max: 200, GROUP_A: 55.63, GROUP_B: 65.09 },
      { min: 201, max: 500, GROUP_A: 45.64, GROUP_B: 53.40 },
      { min: 501, max: 2000, GROUP_A: 42.37, GROUP_B: 49.57 },
      { min: 2001, max: 5000, GROUP_A: 31.96, GROUP_B: 37.39 },
    ]
  },
  { category: RecProjectCategory.TRADITIONAL_COMMUNITY_SOLAR,
    year: RecProgramYear.YEAR_2026_2027,
    data: [
      { min: 0, max: 25, GROUP_A: 57.49, GROUP_B: 70.91 },
      { min: 26, max: 100, GROUP_A: 58.84, GROUP_B: 72.15 },
      { min: 101, max: 200, GROUP_A: 57.50, GROUP_B: 69.58 },
      { min: 201, max: 500, GROUP_A: 53.46, GROUP_B: 64.20 },
      { min: 501, max: 2000, GROUP_A: 46.02, GROUP_B: 54.24 },
      { min: 2001, max: 5000, GROUP_A: 33.99, GROUP_B: 39.98 },
    ]
  },
  { category: RecProjectCategory.COMMUNITY_DRIVEN_COMMUNITY_SOLAR,
    year: RecProgramYear.YEAR_2026_2027,
    data: [
      { min: 0, max: 25, GROUP_A: 80.66, GROUP_B: 96.74 },
      { min: 26, max: 100, GROUP_A: 81.88, GROUP_B: 97.27 },
      { min: 101, max: 200, GROUP_A: 78.09, GROUP_B: 93.45 },
      { min: 201, max: 500, GROUP_A: 68.02, GROUP_B: 85.02 },
      { min: 501, max: 2000, GROUP_A: 58.77, GROUP_B: 71.34 },
      { min: 2001, max: 5000, GROUP_A: 50.48, GROUP_B: 57.35 },
    ]
  },
  { category: RecProjectCategory.PUBLIC_SCHOOLS,
    year: RecProgramYear.YEAR_2026_2027,
    data: [
      { min: 0, max: 25, GROUP_A: 77.17, GROUP_B: 93.17 },
      { min: 26, max: 100, GROUP_A: 68.57, GROUP_B: 84.96 },
      { min: 101, max: 200, GROUP_A: 65.81, GROUP_B: 76.91 },
      { min: 201, max: 500, GROUP_A: 57.72, GROUP_B: 66.88 },
      { min: 501, max: 2000, GROUP_A: 54.51, GROUP_B: 61.04 },
      { min: 2001, max: 5000, GROUP_A: 42.15, GROUP_B: 46.74 },
    ]
  },
];

